import { render } from "./ColliUscitaTable.vue?vue&type=template&id=237878e5&scoped=true"
import script from "./ColliUscitaTable.vue?vue&type=script&lang=js"
export * from "./ColliUscitaTable.vue?vue&type=script&lang=js"

import "./ColliUscitaTable.vue?vue&type=style&index=0&id=237878e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237878e5"]])

export default __exports__